import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { ErrorBoundary } from './app/ErrorBoundary';
import './styles.css';

/**
 * Der Einstiegspunkt.
 *
 * **Ohne `StrictMode`, und das ist eine Entscheidung.** Der doppelte
 * Effektlauf im Entwicklungsmodus ist für die meisten Anwendungen ein
 * nützlicher Test — hier aber liegt hinter einem Effekt eine Anfrage, die
 * **nicht** wiederholbar ist: `POST /auth/totp/enroll` erzeugt jedes Mal ein
 * neues Geheimnis. Ein zweiter Lauf machte den eben angezeigten QR-Code
 * stillschweigend ungültig. Die Komponente sichert sich zusätzlich mit einem
 * `useRef` ab (siehe `TotpEnrollForm`); beides zusammen ist der Preis dafür,
 * dass eine Einrichtung nur einmal stattfindet.
 *
 * **`ErrorBoundary` umschliesst den GANZEN Baum, auch die Anmeldemaske** —
 * Auftrag `W-frischebundle`. Ein `removeChild`-Absturz aus `react-dom`
 * (React-Issue #11538, ausgelöst durch eine DOM-mutierende
 * Browser-Erweiterung oder Chromes Übersetzer) zeigte bis dahin eine
 * komplett weisse Seite ohne jede Erklärung. Begründung, Chunk-
 * Selbstheilung und Schleifenschutz stehen in `app/ErrorBoundary.tsx`.
 */
const container = document.getElementById('root');
if (container === null) {
  throw new Error('Der Wurzelknoten #root fehlt in index.html.');
}

createRoot(container).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);
